import ReachOut from "../../Components/Landing/ReachOut";
import { useEffect, useState } from "react";
import { showLoader } from "../../Redux/Slices/loaderSlice";
import { get_posts_public, getallaboutUs_public } from "../../Redux/Actions/action";
import { useDispatch } from "react-redux";
import { BucketURL } from "../../ApiSetup/Api";
import { Box, Button, Container, Divider, Grid, Typography, useTheme } from "@mui/material";
import CommonContainer from "../../Components/Landing/CommonContainer";
import AboutUsCommon from "../../Components/Landing/AboutUsCommon";

const data = [
    {
        image: "/images/affordability-1.png",
        text: "Financial Assistance (Sahaynidhi)",
    },
    {
        image: "/images/Group-(1).png",
        text: "Health & Medical Support",
    },
    {
        image: "/images/Group-(2).png",
        text: "Family Welfare Programs",
    },
    {
        image: "/images/Group-(3).png",
        text: "Community Unity & Togetherness",
    },
    {
        image: "/images/Group-(4).png",
        text: "Education & Youth Empowerment",
    },
    {
        image: "/images/Group@2x.png",
        text: "Compassion & Care for Members",
    },
    {
        image: "/images/Group-(5).png",
        text: "Security & Peace of Mind",
    },
    {
        image: "/images/Group-(6).png",
        text: "Compassion & Care for Members",
    },
    {
        image: "/images/Group-(7).png",
        text: "Sustainable Welfare Initiatives",
    },
];

const steps = [
    {
        number: "01",
        title: "Scan QR & Download",
        description:
            "Go to the PPSK Home Page, scan the QR code, and download the PPSK App.",
    },
    {
        number: "02",
        title: "Registration Form",
        description:
            "Fill out the PPSK Registration Form with your personal and family details to join the initiative.",
    },
    {
        number: "03",
        title: "Submit Required Documents",
        description:
            "Submit the required documents for verification to complete your PPSK registration.",
    },
    {
        number: "04",
        title: "Complete Payment",
        description:
            "Complete the membership fee payment securely through the PPSK App.",
    },
    {
        number: "05",
        title: "Stay Connected",
        description:
            "Stay connected with PPSK to access welfare programs, updates, and community initiatives anytime.",
    },
];

const AboutUs = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const [bgImage, setBgImage] = useState([]);
    const [aboutUsData, setAboutUsData] = useState([]);

    const fetchData = async (params, setter) => {
        dispatch(showLoader(true));
        try {
            const res = await dispatch(get_posts_public(params));
            setter(res.payload.data.data);
            dispatch(showLoader(false));
        } catch (err) {
            dispatch(showLoader(false));
        }
    };

    const _getallaboutUs = async (params, setter) => {
        dispatch(showLoader(true));
        try {
            const res = await dispatch(getallaboutUs_public(params));
            setAboutUsData(res.payload?.data?.response?.[0]);
            dispatch(showLoader(false));
        } catch (err) {
            dispatch(showLoader(false));
        }
    };

    useEffect(() => {
        fetchData(
            {
                type: "Hero-Banner",
                status: "Active",
                page: 1,
            },
            setBgImage
        );
        _getallaboutUs()
    }, []);

    return (
        <div>
            <Box>
                {bgImage?.map((item, index) => (
                    <Box key={index} sx={{ position: "relative" }}>
                        <img
                            src={BucketURL + item.heroBannerDetails?.bannerImage}
                            alt={item.heroBannerDetails?.eventName || "Hero Banner"}
                            style={{
                                filter: "brightness(0.3)",
                                width: "100%",
                                objectFit: "cover",
                                maxHeight: "320px",
                            }}
                        />
                        <Box
                            sx={{
                                position: "absolute",
                                zIndex: 1,
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                textAlign: "center",
                                color: "#fff",
                                maxWidth: "1200px",
                                width: "100%",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: { lg: "34px", md: "20px", sm: "16px", xs: "16px" },
                                    fontWeight: "bold",
                                }}
                            >
                                About Us
                            </Typography>
                            <Typography
                                fontWeight={"normal"}
                                sx={{
                                    fontSize: { lg: "16px", md: "14px", sm: "13x", xs: "12px" },
                                }}
                            >
                                PPSK is a community-driven initiative providing security, care,
                                and sahaynidhi support to Patidar families worldwide.
                            </Typography>
                        </Box>
                    </Box>
                ))}
            </Box>
            <AboutUsCommon data={aboutUsData} />
            <CommonContainer>
                <Grid container spacing={2}>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box
                            bgcolor={theme.palette.common.white}
                            padding={3}
                            borderRadius={"20px"}
                            borderBottom={`15px solid ${theme.palette.primary.main}`}
                        >
                            <img src="/images/Frame.png" height={"45px"} width={"45px"} />
                            <Box mt={1}>
                                <Typography
                                    color="primary"
                                    sx={{
                                        fontSize: {
                                            lg: "26px",
                                            md: "16px",
                                            sm: "16px",
                                            xs: "16px",
                                        },
                                        fontWeight: "bold",
                                    }}
                                >
                                    {"PPSK Vision"}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: {
                                            lg: "18px",
                                            md: "14px",
                                            sm: "12px",
                                            xs: "12px",
                                        },
                                        color: "rgba(34, 34, 34, 1)",
                                    }}
                                >
                                    {
                                        "The vision of PPSK is to create a strong, united Patidar community rooted in care, compassion, and togetherness. We aspire to ensure every family feels secure, supported, and empowered during life’s challenges."
                                    }
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box
                            bgcolor={theme.palette.common.white}
                            padding={3}
                            borderRadius={"20px"}
                            borderBottom={`15px solid ${theme.palette.primary.main}`}
                        >
                            <img src="/images/Group.png" height={"45px"} width={"45px"} />
                            <Box mt={1}>
                                <Typography
                                    color="primary"
                                    sx={{
                                        fontSize: {
                                            lg: "26px",
                                            md: "16px",
                                            sm: "16px",
                                            xs: "16px",
                                        },
                                        fontWeight: "bold",
                                    }}
                                >
                                    {"PPSK Mission"}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: {
                                            lg: "18px",
                                            md: "14px",
                                            sm: "12px",
                                            xs: "12px",
                                        },
                                        color: "rgba(34, 34, 34, 1)",
                                    }}
                                >
                                    {
                                        "PPSK’s mission is to support Patidar families with sahaynidhi assistance, care, and guidance during life’s challenges. We are dedicated to fostering unity, compassion, and peace of mind across the community."
                                    }
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                        <Box
                            bgcolor={theme.palette.common.white}
                            padding={3}
                            borderRadius={"20px"}
                            borderBottom={`15px solid ${theme.palette.primary.main}`}
                        >
                            <img src="/images/Frame-1.png" height={"45px"} width={"45px"} />
                            <Box mt={1}>
                                <Typography
                                    color="primary"
                                    sx={{
                                        fontSize: {
                                            lg: "26px",
                                            md: "16px",
                                            sm: "16px",
                                            xs: "16px",
                                        },
                                        fontWeight: "bold",
                                    }}
                                >
                                    {"PPSK Goal"}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: {
                                            lg: "18px",
                                            md: "14px",
                                            sm: "12px",
                                            xs: "12px",
                                        },
                                        color: "rgba(34, 34, 34, 1)",
                                    }}
                                >
                                    {
                                        "The goal of PPSK is to build a strong support system that ensures the well-being and security of Patidar families. We aim to promote unity, trust, and collective strength through meaningful initiatives and assistance programs."
                                    }
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </CommonContainer>
            <CommonContainer>
                <Typography
                    color={"primary"}
                    sx={{
                        fontSize: { lg: "52px", md: "30px", sm: "26px", xs: "20px" },
                        fontWeight: "normal",
                    }}
                >
                    Our Objective
                </Typography>
                <Typography
                    sx={{
                        fontSize: { lg: "20px", md: "16px", sm: "16px", xs: "12px" },
                        color: "#4b4c4c",
                        mb: { lg: 3, mg: 3, sm: 2, xs: 1 },
                        fontWeight: '400'
                    }}
                >
                    {" "}
                    Our objective is to provide timely sahaynidhi support, healthcare
                    assistance, and welfare programs for Patidar families in need. We aim
                    to empower youth through education, promote unity, and foster
                    compassion within the community. By building sustainable initiatives,
                    PPSK ensures long-term security and peace of mind for every family.
                </Typography>
                <Grid container spacing={2}>
                    {data?.map((item, index) => {
                        return (
                            <Grid item lg={4} md={4} sm={6} xs={12} key={index}>
                                <Box
                                    bgcolor={"rgba(3, 119, 124, 0.1)"}
                                    padding={"16px 16px"}
                                    borderRadius={"10px"}
                                    border={`1px solid rgba(3, 119, 124, 0.6)`}
                                    display={"flex"}
                                    alignItems={"center"}
                                    gap={2}
                                >
                                    <img src={item?.image} height={"40px"} width={"40px"} />
                                    <Divider
                                        orientation="vertical"
                                        flexItem
                                        sx={{
                                            borderColor: theme.palette.primary.main,
                                            borderRightWidth: 1,
                                        }}
                                    />
                                    <Typography
                                        color="primary"
                                        sx={{
                                            fontSize: {
                                                lg: "16px",
                                                md: "14px",
                                                sm: "13px",
                                                xs: "12px",
                                            },
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {item.text}
                                    </Typography>
                                </Box>
                            </Grid>
                        )
                    })}
                </Grid>
            </CommonContainer>
            <Container>
                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                    <Typography
                        color={"primary"}
                        sx={{
                            fontSize: { lg: "52px", md: "30px", sm: "26px", xs: "20px" },
                            fontWeight: "normal",
                        }}
                    >
                        How to Join PPSK
                    </Typography>
                    <Button
                        sx={{
                            mt: 2,
                            width: '138px',
                            padding: '6px 14px',
                            position: 'relative',
                            overflow: 'hidden',
                            borderRadius: '10px',
                            backgroundColor: theme.palette.primary.main,
                            color: 'white',
                            fontSize: '16px',
                            fontFamily: 'Lato, sans-serif',
                            textTransform: 'none',
                            zIndex: 1,
                            '&:hover': {
                                backgroundColor: theme.palette.primary.main,
                            },
                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                width: 0,
                                height: 0,
                                top: '50%',
                                left: '50%',
                                backgroundColor: '#9e110c',
                                borderRadius: '50%',
                                transform: 'translate(-50%, -50%)',
                                zIndex: -1,
                                transition: 'all 500ms ease-in-out',
                            },
                            '&:hover::before': {
                                width: '300px',
                                height: '300px',
                            },
                        }}
                        onClick={() => window.open("https://play.google.com/store/apps/details?id=com.webito.ppsk&hl=en_IN")}
                    >
                        Get App
                    </Button>
                </Box>
            </Container>
            <Box sx={{ py: 5, px: 4, position: "relative" }}>
                <Box
                    sx={{
                        position: "absolute",
                        top: 70,
                        left: 0,
                        right: 0,
                        height: 20,
                        background: "rgba(154, 201, 203, 1)",
                        display: { lg: 'block', md: 'block', sm: 'none', xs: 'none' }
                    }}
                />
                <Box
                    sx={{
                        position: "absolute",
                        top: 79.5,
                        left: 0,
                        right: 0,
                        height: "1px",
                        backgroundImage: "repeating-linear-gradient(to right, #2b7a78, #2b7a78 4px, transparent 4px, transparent 10px)",
                        display: { lg: 'block', md: 'block', sm: 'none', xs: 'none' }
                    }}
                />
                <Container>
                    <Grid container spacing={4} justifyContent="center" alignItems="flex-start">
                        {steps.map((step, index) => (
                            <Grid item xs={12} sm={6} md={2.4} key={index}>
                                <Box textAlign="center" sx={{ position: "relative", zIndex: 1 }}>
                                    <Box
                                        sx={{
                                            width: 60,
                                            height: 60,
                                            borderRadius: "50%",
                                            backgroundColor: "rgba(3, 119, 124, 1)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            margin: "0 auto",
                                            mb: 2,
                                            color: "white",
                                            fontWeight: "bold",
                                            fontSize: "18px",
                                            border: '10px solid rgba(154, 201, 203, 1)',
                                            position: 'relative',
                                        }}
                                    >
                                        {step.number}
                                    </Box>
                                    <Typography color={"primary"} variant="subtitle1" fontWeight="bold" gutterBottom>
                                        {step.title}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {step.description}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>
            <ReachOut />
        </div>
    );
};

export default AboutUs;
